var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-common-form-approval"},[_c('form-create',{ref:"formCreate",attrs:{"rule":_vm.formRule,"option":_vm.formOption,"value":_vm.formData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }